
<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>





<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>


<br><br>



<!-- topic -->
<div class="row" data-aos="zoom-in" data-aos-delay="300"   >
  <div class="col-md-6 text-center">
    <img style="width:70%;height: 100%;margin-top: 40px;" src="assets/passportverify.png">
</div>
    <div style="padding-top: 10%;" class="col-md-6">
        <h1>
            <span class="topic">Passport Verification API Solution</span>
          </h1>
        <h5 style="padding-left: 10%;">&nbsp;&nbsp;&nbsp;Reliable, fast and easy passport number verification</h5>
    </div>

   
</div>
<br><br>
<br><br>


<!-- passport -->

<!-- drive -->
<div class="row"  data-aos="fade-up" data-aos-delay="300"  >
    <div class="col">
        <h1 style="text-align: center;font-weight:700;">Fast. Accurate. Efficient.</h1>
        <h6 style="color: gray;text-align: center;">Your line of defense against impersonation frauds and stolen identities</h6>
        <br><br>
       
    </div>
</div>

<div class="row"   >
    <div class="col-md-4" data-aos="fade-up" data-aos-delay="300"  >
        
        <img style="width: 40px;height: 40px;margin-left: 27%;" src="assets/targeted.png"><br><br>
        <h3 style="margin-left: 27%;">99.9%</h3>
        <h4 style="margin-left: 23%;color: #6ab187;">Check Success Rate</h4>

    </div>

    <div class="col-md-4" data-aos="fade-up" data-aos-delay="300"  >
        
        <img style="width: 40px;height: 40px;margin-left: 27%;" src="assets/accuracy.png"><br><br>
        <h3 style="margin-left: 27%;">99%</h3>
        <h4 style="margin-left: 23%;color: #6ab187;">Verification Accuracy</h4>
        
    </div>

    
    <div class="col-md-4" data-aos="fade-up" data-aos-delay="300"   >
        
        <img style="width: 40px;height: 40px;margin-left: 27%;" src="assets/responsetime.png"><br><br>
        <h3 style="margin-left: 27%;">1-5 Secs</h3>
        <h4 style="margin-left: 23%;color: #6ab187;">Response Time</h4>
        
    </div>
</div>
<br><br><br>


<div class="row" data-aos="zoom-in" data-aos-delay="300" >
    <div style="text-align: center;" class="col">
      <h2 style="color:#6ab187;">Instant Verification Check</h2><br>
      <h3>Real Time Verification of Passport </h3>
      <h5 style="color: gray;">Determine the legitimacy of the individual by verifying their passport number.</h5>
    </div>
  </div>
  <br><br><br>


  
<div class="row p-4" data-aos="fade-up" data-aos-delay="300"   >
    <div  class="col-md-6">
        <img style="width: 60px;height: 60px;" src="assets/flightpassport.png"><br><br>
      <h5 style="color: #6ab187;">Passport Verification</h5>
      <h3>What does a Passport Verification API do? </h3>
      <h6><img style="width:20px;height: 20px;" src="assets/check-mark.png">Swiftly authenticate Passport information by cross-referencing it with the official Government database.</h6>
      <h6><img style="width:20px;height: 20px;" src="assets/check-mark.png">This streamlines the onboarding procedure, enhancing its safety, speed, and efficiency. With the help of Passport Verification API, you can rest assured that the individuals you’re onboarding possess legitimate credentials and have supplied accurate identity documentation.</h6>
      <h6><img style="width:20px;height: 20px;" src="assets/check-mark.png">Combine this with Passport OCR API for a seamless and instantaneous identity verification and onboarding experience.</h6>
      <br>
    
      <h6 style="color: #6ab187;">Get Started<img style="width: 30px;height: 30px;" src="assets/arroww.jpg"> </h6>
    </div>
  
    <div class="col-md-6 text-center" >
      <img style="border-radius: 50%;width: 90%;margin-top: 27px;" src="assets/passportapi.png">
    </div>
  </div>
  
  <br>


  <div class="row" data-aos="zoom-in" data-aos-delay="300" >
    <div style="text-align: center;" class="col">
      <h5>How to Verify the Passport?</h5>
      <h1 style="color: #6ab187;">How FACheck's Passport Verification API works?</h1>
      <h5 style="color: gray;">Step by step guide to do instant passport verification</h5>
      <br><br>
    </div>
  
 
  <br><br>
  </div>
   <div  class="row p-4">
  
    <div  data-aos="fade-up" data-aos-delay="300" class="col-md-4">
        <br>
        <img style="width: 60px;height: 65px;" src="assets/uploads.jpg">
       <br><br><br>
        <h5>STEP 1</h5>
        <p style="align-items: center;">User uploads the passport number, DoB, <br>full name of the individual</p>
    </div>
  
    <div  data-aos="fade-up" data-aos-delay="300"  class="col-md-4">
          <br>
          <img style="width: 70px;height: 60px;margin-left: 30px;" src="assets/details.png">
         <br><br><br>
          <h5 style="margin-left: 30px;">STEP 2</h5>
          <p style="align-items: center;margin-left: 30px;">API verifies the details</p>
      </div>
     
      <div   data-aos="fade-up" data-aos-delay="300" class="col-md-4">
     
        <br>
        <img style="width: 60px;height: 60px;" src="assets/machine-readable.png">
       <br><br><br>
        <h5 >STEP 3</h5>
        <p style="align-items: center;">Generate Machine readable files from a<br> Passport number and other identity details as input<p>
    </div>
  
  </div>





